import Gator from 'gator';
import jump from 'jump.js';

let dateSelect = document.getElementById('date');

let timeNodes;
let statusNodes;
let registerNodes;
let form;
let action;
let hash = window.location.hash.substr(1);
const registerClass = 'workshop__register';
const statusContainerClass = 'workshop__statusrow';

if (dateSelect) {
    [...document.querySelectorAll(`.${statusContainerClass}`)].forEach(element => {
        element.classList.remove(`${statusContainerClass}--hidden`);
    });

    form = document.forms.register;
    if (form) {
        action = form.action;
    }
    statusNodes = [...document.querySelectorAll('.workshop__status')];
    timeNodes = [...document.querySelectorAll('.workshop__time')];
    registerNodes = [...document.querySelectorAll(`.${registerClass}`)];

    if (hash && hash.length) {
        let option = dateSelect.querySelector(`[data-uri='${hash}']`);
        if (option) {
            dateSelect.value = option.value;
        }
    }

    onDateChange();
    Gator(dateSelect).on('change', onDateChange);
}

function onDateChange(event) {
    let option = dateSelect.options[dateSelect.selectedIndex];
    let dataset = option.dataset;

    if (event) {
        history.pushState('', document.title, `#${dataset.uri}`);
    }

    timeNodes.forEach(element => {
        element.innerText = dataset.time;
    });

    statusNodes.forEach(element => {
        element.innerText = dataset.status || '';
    });
    registerNodes.forEach(element => {
        element.classList[dataset.allowed == undefined ? 'add' : 'remove'](`${registerClass}--hidden`);
    });
    if (dataset.allowed == undefined || !form) {
        return;
    }
    form.elements.nodeId.value = option.value;
    form.elements.eventDate.value = dataset.date || '';
    form.elements.eventStartTime.value = dataset.start || '';
    form.elements.eventEndTime.value = dataset.end || '';

    if (action) {
        form.action = `${action}#${dataset.uri}`;
    }

    if (form.dataset.jump != undefined) {
        setTimeout(() => {
            jump('#form');
        }, 100);
    }
}
